import React, { createContext, useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [userName, setUserName] = useState(
    localStorage.getItem("userName") || ""
  );
  const [userType, setUserType] = useState(
    localStorage.getItem("userType") || ""
  );
  const [userId, setUserId] = useState(localStorage.getItem("userId") || "");
  const [emailId, setEmailId] = useState(localStorage.getItem("emailId") || "");
  const [contactdetails, setContactdetails] = useState(
    localStorage.getItem("contactdetails") || ""
  );
  const [phoneno, setPhoneno] = useState(localStorage.getItem("phoneno") || "");

  const [billing_user_name, setBilling_user_name] = useState(
    localStorage.getItem("billing_user_name") || ""
  );
  const [billingAddress1, setBillingAddress1] = useState(
    localStorage.getItem("billingAddress1") || ""
  );
  const [billingAddress2, setBillingAddress2] = useState(
    localStorage.getItem("billingAddress2") || ""
  );
  const [billingCity, setBillingCity] = useState(
    localStorage.getItem("billingCity") || ""
  );
  const [billingCountry, setBillingCountry] = useState(
    localStorage.getItem("billingCountry") || ""
  );
  const [billingPin_code, setBillingPin_code] = useState(
    localStorage.getItem("billingPin_code") || ""
  );
  const [billingState, setBillingState] = useState(
    localStorage.getItem("billingState") || ""
  );
  const [billing_mobile, setBilling_mobile] = useState(
    localStorage.getItem("billing_mobile") || ""
  );

  const [shipping_user_name, setShipping_user_name] = useState(
    localStorage.getItem("shipping_user_name") || ""
  );
  const [shippingAddress1, setShippingAddress1] = useState(
    localStorage.getItem("shippingAddress1") || ""
  );
  const [shippingAddress2, setShippingAddress2] = useState(
    localStorage.getItem("shippingAddress2") || ""
  );
  const [shippingCity, setShippingCity] = useState(
    localStorage.getItem("shippingCity") || ""
  );
  const [shippingCountry, setShippingCountry] = useState(
    localStorage.getItem("shippingCountry") || ""
  );
  const [shippingPin_code, setShippingPin_code] = useState(
    localStorage.getItem("shippingPin_code") || ""
  );
  const [shippingState, setShippingState] = useState(
    localStorage.getItem("shippingState") || ""
  );
  const [shipping_mobile, setShipping_mobile] = useState(
    localStorage.getItem("shipping_mobile") || ""
  );

  const updateUserDetails = (newUserDetails) => {
    setUserDetails(newUserDetails);
    localStorage.setItem("token", newUserDetails.token);
    localStorage.setItem("userName", newUserDetails.userName);
    localStorage.setItem("userType", newUserDetails.userType);
    localStorage.setItem("userId", newUserDetails.userId);
    localStorage.setItem("emailId", newUserDetails.emailId);
    localStorage.setItem("phoneno", newUserDetails.phoneno);
    localStorage.setItem("contactdetails", newUserDetails.contactdetails);

    localStorage.setItem("billing_user_name", newUserDetails.billing_user_name);
    localStorage.setItem("billingAddress1", newUserDetails.billingAddress1);
    localStorag2.setItem("billingAddress2", newUserDetails.billingAddress1);
    localStorag2.setItem("billingCity", newUserDetails.billingCity);
    localStorag2.setItem("billingCountry", newUserDetails.billingCountry);
    localStorag2.setItem("billingPin_code", newUserDetails.billingPin_code);
    localStorag2.setItem("billingState", newUserDetails.billingState);
    localStorag2.setItem("billing_mobile", newUserDetails.billing_mobile);

    localStorage.setItem(
      "shipping_user_name",
      newUserDetails.shipping_user_name
    );
    localStorage.setItem("shippingAddress1", newUserDetails.shippingAddress1);
    localStorage.setItem("shippingAddress2", newUserDetails.shippingAddress2);
    localStorage.setItem("shippingCity", newUserDetails.shippingCity);
    localStorage.setItem("shippingCountry", newUserDetails.shippingCountry);
    localStorage.setItem("shippingPin_code", newUserDetails.shippingPin_code);
    localStorage.setItem("shippingState", newUserDetails.shippingState);
    localStorage.setItem("shipping_mobile", newUserDetails.shipping_mobile);
  };

  const updateToken = (newToken) => {
    setToken(newToken);
    localStorage.setItem("token", newToken);
  };

  const updateUserName = (newUserName) => {
    setUserName(newUserName);
    localStorage.setItem("userName", newUserName);
  };

  const updateUserType = (newUserType) => {
    setUserType(newUserType);
    localStorage.setItem("userType", newUserType);
  };

  const updateUserId = (newUserId) => {
    setUserId(newUserId);
    localStorage.setItem("userId", newUserId);
  };

  const updateEmailId = (newEmailId) => {
    setEmailId(newEmailId);
    localStorage.setItem("emailId", newEmailId);
  };

  const updatePhoneno = (newPhoneno) => {
    setPhoneno(newPhoneno);
    localStorage.setItem("phoneno", newPhoneno);
  };

  const updateContactdetails = (newContactdetails) => {
    setContactdetails(newContactdetails);
    localStorage.setItem("contactdetails", newContactdetails);
  };

  const updateBilling_user_name = (newBilling_user_name) => {
    setBilling_user_name(newBilling_user_name);
    localStorage.setItem("billing_user_name", newBilling_user_name);
  };

  const updateBillingAddress1 = (newBillingAddress1) => {
    setBillingAddress1(newBillingAddress1);
    localStorage.setItem("billingAddress1", newBillingAddress1);
  };

  const updateBillingAddress2 = (newBillingAddress2) => {
    setBillingAddress1(newBillingAddress2);
    localStorage.setItem("billingAddress2", newBillingAddress2);
  };

  const updateBillingCity = (newbillingCity) => {
    setBillingCity(newbillingCity);
    localStorage.setItem("billingCity", newbillingCity);
  };

  const updateBillingCountry = (newbillingCountry) => {
    setBillingAddress1(newbillingCountry);
    localStorage.setItem("billingCountry", newBillingCountry);
  };

  const updateBillingPin_code = (newbillingPin_code) => {
    setBillingPin_code(newbillingPin_code);
    localStorage.setItem("billingPin_code", newbillingPin_code);
  };

  const updateBillingState = (newbillingState) => {
    setBillingState(newbillingState);
    localStorage.setItem("billingState", newbillingState);
  };

  const updateBilling_mobile = (newbilling_mobile) => {
    setBilling_mobile(newbilling_mobile);
    localStorage.setItem("billing_mobile", newbilling_mobile);
  };

  const updateShipping_user_name = (newshipping_user_name) => {
    setShipping_user_name(newshipping_user_name);
    localStorage.setItem("shipping_user_name", newshipping_user_name);
  };

  const updateShippingAddress1 = (newShippingAddress1) => {
    setShippingAddress1(newShippingAddress1);
    localStorage.setItem("shippingAddress1", newShippingAddress1);
  };

  const updateShippingAddress2 = (newShippingAddress2) => {
    setShippingAddress2(newShippingAddress2);
    localStorage.setItem("shippingAddress2", newShippingAddress2);
  };

  const updateShippingCity = (newShippingCity) => {
    setShippingCity(newShippingCity);
    localStorage.setItem("shippingCity", newShippingCity);
  };

  const updateShippingCountry = (newShippingCountry) => {
    setShippingAddress1(newShippingCountry);
    localStorage.setItem("shippingCountry", newShippingCountry);
  };

  const updateShippingPin_code = (newShippingPin_code) => {
    setShippingPin_code(newShippingPin_code);
    localStorage.setItem("shippingPin_code", newShippingPin_code);
  };

  const updateShippingState = (newShippingState) => {
    setShippingState(newShippingState);
    localStorage.setItem("shippingState", newShippingState);
  };

  const updateShipping_mobile = (newShipping_mobile) => {
    setShipping_mobile(newShipping_mobile);
    localStorage.setItem("shipping_mobile", newShipping_mobile);
  };

  const logout = () => {
    updateUserDetails({
      token: "",
      userName: "",
      userType: "",
      userId: "",
      emailId: "",
      phoneno: "",
      contactdetails: "",

      billing_user_name: "",
      billingAddress1: "",
      billingAddress2: "",
      billingCity: "",
      billingCountry: "",
      billingPin_code: "",
      billingState: "",
      billing_mobile: "",

      shipping_user_name: "",
      shippingAddress1: "",
      shippingAddress2: "",
      shippingCity: "",
      shippingCountry: "",
      shippingPin_code: "",
      shippingState: "",
      shipping_mobile: "",
    });

    setToken("");
    setUserName("");
    setUserType("");
    updateUserId("");
    updateEmailId("");
    updatePhoneno("");
    updateContactdetails("");

    updateBilling_user_name("");
    updateBillingAddress1("");
    updateBillingAddress2("");
    updateBillingCity("");
    updateBillingCountry("");
    updateBillingPin_code("");
    updateBillingState("");
    updateBilling_mobile("");

    updateShipping_user_name("");
    updateShippingAddress1("");
    updateShippingAddress2("");
    updateShippingCity("");
    updateShippingCountry("");
    updateShippingPin_code("");
    updateShippingState("");
    updateShipping_mobile("");

    localStorage.removeItem("token");
    localStorage.removeItem("userName");
    localStorage.removeItem("userType");
    localStorage.removeItem("userId");
    localStorage.removeItem("emailId");
    localStorage.removeItem("phoneno");
    localStorage.removeItem("contactdetails");

    localStorage.removeItem("billing_user_name");
    localStorage.removeItem("billingAddress1");
    localStorage.removeItem("billingAddress2");
    localStorage.removeItem("billingCity");
    localStorage.removeItem("billingCountry");
    localStorage.removeItem("billingPin_code");
    localStorage.removeItem("billingState");
    localStorage.removeItem("billing_mobile");

    localStorage.removeItem("shipping_user_name");
    localStorage.removeItem("shippingAddress1");
    localStorage.removeItem("shippingAddress2");
    localStorage.removeItem("shippingCity");
    localStorage.removeItem("shippingCountry");
    localStorage.removeItem("shippingPin_code");
    localStorage.removeItem("shippingState");
    localStorage.removeItem("shipping_mobile");
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        updateToken,
        userName,
        updateUserName,
        userType,
        updateUserType,
        userId,
        updateUserId,
        emailId,
        updateEmailId,
        phoneno,
        updatePhoneno,
        contactdetails,
        updateContactdetails,
        billingAddress1,
        updateBillingAddress1,
        billingAddress2,
        updateBillingAddress2,
        shippingAddress1,
        updateShippingAddress1,
        shippingAddress2,
        updateShippingAddress2,
        billingCity,
        updateBillingCity,
        billingCountry,
        updateBillingCountry,
        billingPin_code,
        updateBillingPin_code,
        billingState,
        updateBillingState,
        billing_mobile,
        updateBilling_mobile,
        shippingCity,
        updateShippingCity,
        shippingCountry,
        updateShippingCountry,
        shippingPin_code,
        updateShippingPin_code,
        shippingState,
        updateShippingState,
        shipping_mobile,
        updateShipping_mobile,
        billing_user_name,
        updateBilling_user_name,
        shipping_user_name,
        updateShipping_user_name,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
